import { html } from 'lit';
const Scissors =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.667 4.75a1.917 1.917 0 1 0 0 3.833 1.917 1.917 0 0 0 0-3.833M3.25 6.667A3.417 3.417 0 1 1 9.568 8.47l2.721 2.51 7.202-6.643A.75.75 0 0 1 20.51 5.44L9.569 15.53a3.417 3.417 0 1 1-1.053-1.07L11.183 12 8.515 9.54A3.417 3.417 0 0 1 3.25 6.666m10.865 7.017a.75.75 0 0 1 1.06-.042l5.333 4.918a.75.75 0 1 1-1.016 1.103l-5.334-4.919a.75.75 0 0 1-.043-1.06m-7.448 1.733a1.917 1.917 0 1 0 0 3.833 1.917 1.917 0 0 0 0-3.833" clip-rule="evenodd"/>
  </svg>
`;
export default Scissors;
